/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type IdleTimeDropdown_idleTimes = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly isInternalTime: boolean | null;
        readonly disabled: boolean | null;
    } | null;
    readonly " $refType": "IdleTimeDropdown_idleTimes";
}>;
export type IdleTimeDropdown_idleTimes$data = IdleTimeDropdown_idleTimes;
export type IdleTimeDropdown_idleTimes$key = ReadonlyArray<{
    readonly " $data"?: IdleTimeDropdown_idleTimes$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"IdleTimeDropdown_idleTimes">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "IdleTimeDropdown_idleTimes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdleTime",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternalTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IdleTimeTypeEdge"
};
(node as any).hash = '31106d34a989d8a8b78b1b3d05815e7d';
export default node;
